import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ComponentsModule} from '../components/components.module';
import {TranslateModule} from '@ngx-translate/core';
import {PipesModule} from '../../pipes/pipes.module';
import {CallsRoutingModule} from './calls-routing.module';
import {CallsAicoachPage} from './calls-aicoach-page/calls-aicoach.page';
import {CallsHistoryPage} from './calls-history-page/calls-history.page';
import {CallsHistoryIframePage} from './calls-history-iframe-page/calls-history-iframe.page';
import {CallsTeamDashboardPage} from './calls-team-dashboard-page/calls-team-dashboard.page';
import {UserCallsOverviewComponent} from './components/user-calls-overview/user-calls-overview.component';
import {CallDetailsComponent} from './components/call-details/call-details.component';
import {CallDetailsAiCoachingTabComponent} from './components/call-details-ai-coaching-tab/call-details-ai-coaching-tab.component';
import {NewlinePipe} from '../../pipes/newline.pipe';
import {CallDetailsScorecardTabComponent} from './components/call-details-scorecard-tab/call-details-scorecard-tab.component';
import {CallDetailsEvalCardRowComponent} from './components/call-details-eval-card-row/call-details-eval-card-row.component';
import {CallDetailsChatComponent} from './components/card-details-chat/call-details-chat.component';
import {SecToStringPipe} from '../../pipes/sec-to-string.pipe';
import {CallDetailsPage} from './call-details-page/call-details.page';
import {
  CallDetailsAiCoachingTabPrintComponent
} from './components/call-details-ai-coaching-tab-print/call-details-ai-coaching-tab-print.component';
import { CallsCardsComponent } from './calls-team-dashboard-page/components/calls-cards/calls-cards.component';
import { CallsTableComponent } from './calls-team-dashboard-page/components/calls-table/calls-table.component';
import { CallsDashboardPage } from './calls-dashboard-page/calls-dashboard.page';
import { NgSelectModule } from '@ng-select/ng-select';
import {CallsFilterComponent} from './calls-team-dashboard-page/components/calls-filter/calls-filter.component';
import { CallsCardsAdvancedComponent } from './calls-team-dashboard-page/components/calls-cards-advanced/calls-cards-advanced.component';
import {
  CallsScorecardComponent
} from './calls-team-dashboard-page/components/calls-scorecard/calls-scorecard.component';
import {CallsHeatmapComponent} from './calls-team-dashboard-page/components/calls-heatmap/calls-heatmap.component';
import {NgFloorPipeModule} from 'angular-pipes';

import {CallsExportComponent} from './calls-team-dashboard-page/components/calls-export/calls-export.component';
import {CallAudioPlayerComponent} from './components/call-details/components/call-audio-player/call-audio-player.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CallsRoutingModule,
        ComponentsModule,
        PipesModule,
        TranslateModule.forChild(),
        NewlinePipe,
        SecToStringPipe,
        NgSelectModule,
        NgFloorPipeModule
    ],
  exports: [
    UserCallsOverviewComponent,
    CallDetailsComponent
  ],
    declarations: [
        CallsAicoachPage,
        CallDetailsPage,
        CallsHistoryPage,
        CallsHistoryIframePage,
        UserCallsOverviewComponent,
        CallsExportComponent,
        CallDetailsComponent,
        CallDetailsAiCoachingTabComponent,
        CallDetailsAiCoachingTabPrintComponent,
        CallDetailsScorecardTabComponent,
        CallDetailsEvalCardRowComponent,
        CallsCardsAdvancedComponent,
        CallDetailsChatComponent,
        CallsTeamDashboardPage,
        CallsCardsComponent,
        CallsFilterComponent,
        CallsTableComponent,
        CallsDashboardPage,
        CallsScorecardComponent,
        CallsHeatmapComponent,
        CallAudioPlayerComponent
    ]
})
export class CallsModule {
}
